export const OFFLINE_SYNC_INTERVAL_MS = 10_000;
export const OFFLINE_SYNC_ONLINE_DELAY_MS = 2_000;
export const NAV_DELAY_MS = 2_000;
export const REQUEST_SEARCH_DEBOUNCE_MS = 300;
export const MFA_SESSION_POLL_INTERVAL_MS = 200;
export const MFA_SESSION_PROPAGATION_DELAY_MS = 250;
export const MFA_REFRESH_EVENT_DELAY_MS = 50;
export const MFA_SESSION_QUERY_TIMEOUT_MS = 10_000;
export const MFA_SESSION_MAX_POLL_ATTEMPTS = 5;
export const MFA_SESSION_POLL_BASE_DELAY_MS = 150;
export const COPY_FEEDBACK_TIMEOUT_MS = 2_000;
export const STATUS_RESET_DELAY_MS = 2_000;
export const FOCUS_DELAY_MS = 100;
export const TIMER_UPDATE_INTERVAL_MS = 1_000;
export const TOOLTIP_DELAY_SHORT_MS = 150;
export const TOOLTIP_DELAY_LONG_MS = 300;
export const CHUNK_RETRY_WINDOW_MS = 10_000;

// Service reliability timeouts (spec §1.2)
export const ROS_READ_SERVER_TIMEOUT_MS = 4_000;
export const ROS_READ_CLIENT_TIMEOUT_MS = 8_000;
export const ROS_WRITE_SERVER_TIMEOUT_MS = 6_000;
export const ROS_WRITE_CLIENT_TIMEOUT_MS = 10_000;
export const PLANNING_SERVER_TIMEOUT_MS = 4_000;
export const PLANNING_CLIENT_TIMEOUT_MS = 8_000;
export const MATRIX_SERVER_TIMEOUT_MS = 5_000;
export const MATRIX_CLIENT_TIMEOUT_MS = 9_000;
export const SERVICE_RETRY_BACKOFF_BASE_MS = 250;
export const SERVICE_RETRY_BACKOFF_MAX_MS = 750;
